import * as types from "../constants/actionTypes";

export const healthPlanServicesState = {
    isFetching: false,
    isEOBAvailableFetching: false,
    claims: null,
    error: ""
};

export default function healthPlanServicesReducer(state = healthPlanServicesState, action) {
    switch (action.type) {
        case types.LOGOUT:
            return {
                ...state, claims: null, usageDetails: null, claimDetail: null, idCardPdf: null, idCardImage: null, membersList: null, currentMemberId: null, planDetail: null, userProfile: null, eobDocument: null,
                docs: null, authorizations: null, authorizationDetail: null, authorizationApprovalLetter: null, invoices: null, invoiceDetails: null, docDetails: null, docName: null,
                invoicePDF: null, invoicePDFName: null, invoiceAdjustments: null, benefitPlans: null, requestedNewCard: null, subscription: null, crmMessages: null, crmSendMessageResponse: null,
                otherCoverage: null, otherCoverageRequestNumber: null, form: null, notificationPreferences: null, updateAddressResponse: null, paperDocument: null, corrEmailAddress: "placeholder"
            };

        case types.HP_GET_ACCUMULATOR_DATA_START:
            return { ...state, isFetching: true, usageDetails: null, error: null };
        case types.HP_GET_ACCUMULATOR_DATA_SUCCESS:
            return { ...state, usageDetails: action.usage, isFetching: false};
        case types.HP_GET_ACCUMULATOR_DATA_FAILURE:
            return { ...state, isFetching: false, error: action.error };

        case types.HP_GET_SERVICE_CATEGORIES_START:
            return { ...state, isFetching: true, serviceCategories: null, error: null };
        case types.HP_GET_SERVICE_CATEGORIES_SUCCESS:
            return { ...state, serviceCategories: action.serviceCategories, isFetching: false };
        case types.HP_GET_SERVICE_CATEGORIES_FAILURE:
            return { ...state, isFetching: false, error: action.error };

        case types.HP_GET_BENEFIT_PLANS_START:
            return { ...state, isFetching: true, benefitPlans: null, error: null };
        case types.HP_GET_BENEFIT_PLANS_SUCCESS:
            return { ...state, benefitPlans: action.benefitPlans, isFetching: false };
        case types.HP_GET_BENEFIT_PLANS_FAILURE:
            return { ...state, isFetching: false, error: action.error };

        case types.HP_GET_BENEFIT_DOCUMENTS_START:
            return { ...state, isFetching: true, benefitDocuments: null, error: null };
        case types.HP_GET_BENEFIT_DOCUMENTS_SUCCESS:
            return { ...state, benefitDocuments: action.benefitDocuments, isFetching: false };
        case types.HP_GET_BENEFIT_DOCUMENTS_FAILURE:
            return { ...state, isFetching: false, error: action.error };

        case types.HP_GET_BENEFIT_DOCUMENT_START:
            return { ...state, isFetching: true, benefitDocumentData: null, error: null };
        case types.HP_GET_BENEFIT_DOCUMENT_SUCCESS:
            return { ...state, benefitDocumentData: action.benefitDocumentData, isFetching: false };
        case types.HP_GET_BENEFIT_DOCUMENT_FAILURE:
            return { ...state, isFetching: false, error: action.error };

        case types.HP_GET_AUTHORIZATIONS_LIST_START:
            return { ...state, isFetching: true, error: null };
        case types.HP_GET_AUTHORIZATIONS_LIST_SUCCESS:
            return { ...state, authorizations: action.authorizations, isFetching: false };
        case types.HP_GET_AUTHORIZATIONS_LIST_FAILURE:
            return { ...state, isFetching: false, error: action.error };

        case types.HP_GET_AUTHORIZATION_DETAIL_START:
            return { ...state, isFetching: true, error: null };
        case types.HP_GET_AUTHORIZATION_DETAIL_SUCCESS:
            return { ...state, authorizationDetail: action.authorizationDetail, isFetching: false };
        case types.HP_GET_AUTHORIZATION_DETAIL_FAILURE:
            return { ...state, isFetching: false, error: action.error };

        case types.HP_GET_AUTHORIZATION_APPROVAL_LETTER_START:
            return { ...state, isFetching: true, error: null };
        case types.HP_GET_AUTHORIZATION_APPROVAL_LETTER_SUCCESS:
            return { ...state, authorizationApprovalLetter: action.authorizationApprovalLetter, isFetching: false };
        case types.HP_GET_AUTHORIZATION_APPROVAL_LETTER_FAILURE:
            return { ...state, isFetching: false, error: action.error };

        case types.HP_GET_CLAIMS_LIST_START:
            return { ...state, isFetching: true, error: null };
        case types.HP_GET_CLAIMS_LIST_SUCCESS:
            return { ...state, claims: action.claims, isFetching: false };
        case types.HP_GET_CLAIMS_LIST_FAILURE:
            return { ...state, isFetching: false, error: action.error };

        case types.HP_GET_CLAIM_DETAIL_START:
            return { ...state, isFetching: true, error: null };
        case types.HP_GET_CLAIM_DETAIL_SUCCESS:
            return { ...state, claimDetail: action.claimDetail, isFetching: false };
        case types.HP_GET_CLAIM_DETAIL_FAILURE:
            return { ...state, isFetching: false, error: action.error };

        case types.HP_GET_OTHER_COVERAGE_START:
            return { ...state, isFetching: true, error: null };
        case types.HP_GET_OTHER_COVERAGE_SUCCESS:
            return { ...state, otherCoverage: action.otherCoverage, isFetching: false };
        case types.HP_GET_OTHER_COVERAGE_FAILURE:
            return { ...state, isFetching: false, error: action.error };

        case types.HP_UPDATE_OTHER_COVERAGE_START:
            return { ...state, isFetching: true, error: null };
        case types.HP_UPDATE_OTHER_COVERAGE_SUCCESS:
            return { ...state, otherCoverageRequestNumber: action.otherCoverageRequestNumber, isFetching: false };
        case types.HP_UPDATE_OTHER_COVERAGE_FAILURE:
            return { ...state, isFetching: false, error: action.error };

        case types.HP_GET_NOTIFICATION_PREFERENCES_START:
            return { ...state, isFetching: true, error: null };
        case types.HP_GET_NOTIFICATION_PREFERENCES_SUCCESS:
            return { ...state, notificationPreferences: action.notificationPreferences, isFetching: false };
        case types.HP_GET_NOTIFICATION_PREFERENCES_FAILURE:
            return { ...state, isFetching: false, error: action.error };

        case types.HP_UPDATE_NOTIFICATION_PREFERENCES_START:
            return { ...state, isFetching: true, error: null };
        case types.HP_UPDATE_NOTIFICATION_PREFERENCES_SUCCESS:
            return { ...state, notificationPreferences: action.notificationPreferences, isFetching: false };
        case types.HP_UPDATE_NOTIFICATION_PREFERENCES_FAILURE:
            return { ...state, isFetching: false, error: action.error };

        case types.HP_TRIGGER_PAPER_DOCUMENT_START:
            return { ...state, isFetching: true, error: null };
        case types.HP_TRIGGER_PAPER_DOCUMENT_SUCCESS:
            return { ...state, paperDocument: action.triggerPaperDocument, isFetching: false };
        case types.HP_TRIGGER_PAPER_DOCUMENT_FAILURE:
            return { ...state, isFetching: false, error: action.error };

        case types.HP_SUBMIT_CLAIM_APPEAL_START:
            return { ...state, isFetching: true, error: null };
        case types.HP_SUBMIT_CLAIM_APPEAL_SUCCESS:
            return { ...state, appealSubmitStatus: action.success, appealIssueId: action.issueId, isFetching: false };
        case types.HP_SUBMIT_CLAIM_APPEAL_FAILURE:
            return { ...state, isFetching: false, error: action.error };

        case types.HP_GET_IDCARD_START:
            return { ...state, idCardPdf: null, error: null, isFetching: true };
        case types.HP_GET_IDCARD_SUCCESS:
            return { ...state, idCardPdf: action.idCardPdf, downloading: action.downloading, isFetching: false };
        case types.HP_GET_IDCARD_FAILURE:
            return { ...state, isFetching: false, error: action.error };

        case types.HP_GET_IDCARD_IMAGE_START:
            return { ...state, idCardImage: null, error: null, isFetching: true };
        case types.HP_GET_IDCARD_IMAGE_SUCCESS:
            return { ...state, idCardImage: action.idCardImage, isFetching: false };
        case types.HP_GET_IDCARD_IMAGE_FAILURE:
            return { ...state, isFetching: false, error: action.error };

        case types.HP_REQUEST_NEW_IDCARD_START:
            return { ...state, isFetching: true, error: null };
        case types.HP_REQUEST_NEW_IDCARD_SUCCESS:
            return { ...state, requestedNewCard: action.response, isFetching: false };
        case types.HP_REQUEST_NEW_IDCARD_FAILURE:
            return { ...state, isFetching: false, error: action.error };

        case types.HP_GET_MEMBERS_LIST_START:
            return { ...state, isFetching: true, error: null };
        case types.HP_GET_MEMBERS_LIST_SUCCESS:
            return { ...state, membersList: action.membersList, currentMemberId: action.currentMemberId, isFetching: false };
        case types.HP_GET_MEMBERS_LIST_FAILURE:
            return { ...state, isFetching: false, error: action.error };

        case types.HP_GET_CRM_MEMBER_MESSAGES_START:
            return { ...state, isFetching: true, error: null };
        case types.HP_GET_CRM_MEMBER_MESSAGES_SUCCESS:
            return { ...state, crmMessages: action.crmMessages, isFetching: false };
        case types.HP_GET_CRM_MEMBER_MESSAGES_FAILURE:
            return { ...state, isFetching: false, error: action.error };

        case types.HP_SEND_CRM_MESSAGE_START:
            return { ...state, isFetching: true, error: null };
        case types.HP_SEND_CRM_MESSAGE_SUCCESS:
            return { ...state, isFetching: false, crmMessages: action.crmMessages };
        case types.HP_SEND_CRM_MESSAGE_FAILURE:
            return { ...state, isFetching: false, error: action.error };

        case types.HP_CREATE_CRM_TICKET_START:
            return { ...state, isFetching: true, error: null };
        case types.HP_CREATE_CRM_TICKET_SUCCESS:
            return { ...state, isFetching: false, crmSendMessageResponse: action.crmSendMessageResponse };
        case types.HP_CREATE_CRM_TICKET_FAILURE:
            return { ...state, isFetching: false, error: action.error };

        case types.HP_GET_BENEFIT_PLAN_DETAIL_START:
            return { ...state, isFetching: true, planDetail: null, error: null };
        case types.HP_GET_BENEFIT_PLAN_DETAIL_SUCCESS:
            return { ...state, planDetail: action.planDetail, isFetching: false };
        case types.HP_GET_BENEFIT_PLAN_DETAIL_FAILURE:
            return { ...state, isFetching: false, error: action.error };

        case types.HP_GET_IS_MEMBER_DPC_START:
            return { ...state, isFetching: true, isMemberDPC: null, error: null };
        case types.HP_GET_IS_MEMBER_DPC_SUCCESS:
            return { ...state, isMemberDPC: action.isMemberDPC, isFetching: false };
        case types.HP_GET_IS_MEMBER_DPC_FAILURE:
            return { ...state, isFetching: false, error: action.error };

        case types.HP_GET_PROFILE_START:
            return { ...state, isFetching: true, error: null };
        case types.HP_GET_PROFILE_SUCCESS:
            return { ...state, userProfile: action.userProfile, isFetching: false };
        case types.HP_GET_PROFILE_FAILURE:
            return { ...state, isFetching: false, error: action.error };

        case types.HP_UPDATE_MEMBER_ADDRESS_START:
            return { ...state, isFetching: true, error: null };
        case types.HP_UPDATE_MEMBER_ADDRESS_SUCCESS:
            return { ...state, updateAddressResponse: action.updateAddressResponse, isFetching: false };
        case types.HP_UPDATE_MEMBER_ADDRESS_FAILURE:
            return { ...state, isFetching: false, error: action.error };

        case types.HP_GET_CORR_EMAIL_ADDRESS_START:
            return { ...state, isFetching: true, error: null };
        case types.HP_GET_CORR_EMAIL_ADDRESS_SUCCESS:
            return { ...state, corrEmailAddress: action.corrEmailAddress, isFetching: false };
        case types.HP_GET_CORR_EMAIL_ADDRESS_FAILURE:
            return { ...state, isFetching: false, error: action.error };

        case types.HP_GET_EOB_DOCUMENT_START:
            return { ...state, isFetching: true, error: null };
        case types.HP_GET_EOB_DOCUMENT_SUCCESS:
            return { ...state, eobDocument: action.eobDocument, isFetching: false };
        case types.HP_GET_EOB_DOCUMENT_FAILURE:
            return { ...state, isFetching: false, error: action.error };

        case types.HP_GET_DOCUMENTS_LIST_START:
            return { ...state, isFetching: true };
        case types.HP_GET_DOCUMENTS_LIST_SUCCESS:
            return { ...state, docs: action.docs, isFetching: false };
        case types.HP_GET_DOCUMENTS_LIST_FAILURE:
            return { ...state, isFetching: false, error: action.error };

        case types.HP_GET_DOCUMENT_DETAIL_START:
            return { ...state, isFetching: true };
        case types.HP_GET_DOCUMENT_DETAIL_SUCCESS:
            return { ...state, docDetails: action.docDetails, docName: action.docName, isFetching: false };
        case types.HP_GET_DOCUMENT_DETAIL_FAILURE:
            return { ...state, isFetching: false, error: action.error };

        case types.HP_GET_INVOICES_LIST_START:
            return { ...state, isFetching: true };
        case types.HP_GET_INVOICES_LIST_SUCCESS:
            return { ...state, invoices: action.invoices, isFetching: false };
        case types.HP_GET_INVOICES_LIST_FAILURE:
            return { ...state, isFetching: false, error: action.error };

        case types.HP_GET_INVOICE_DETAIL_START:
            return { ...state, isFetching: true };
        case types.HP_GET_INVOICE_DETAIL_SUCCESS:
            return { ...state, invoiceDetails: action.invoiceDetails, isFetching: false };
        case types.HP_GET_INVOICE_DETAIL_FAILURE:
            return { ...state, isFetching: false, error: action.error };

        case types.HP_GET_INVOICE_ADJUSTMENTS_START:
            return { ...state, isFetching: true };
        case types.HP_GET_INVOICE_ADJUSTMENTS_SUCCESS:
            return { ...state, invoiceAdjustments: action.invoiceAdjustments, isFetching: false };
        case types.HP_GET_INVOICE_ADJUSTMENTS_FAILURE:
            return { ...state, isFetching: false, error: action.error };

        case types.HP_GET_INVOICE_PDF_START:
            return { ...state, isFetching: true };
        case types.HP_GET_INVOICE_PDF_SUCCESS:
            return { ...state, invoicePDF: action.invoicePDF, invoicePDFName: action.invoicePDFName, isFetching: false, error: null };
        case types.HP_GET_INVOICE_PDF_FAILURE:
            return { ...state, isFetching: false, error: action.error, invoicePDF: null, invoicePDFName: null };

        case types.HP_GET_FORM_START:
            return { ...state, isFetching: true };
        case types.HP_GET_FORM_SUCCESS:
            return { ...state, form: action.form, isFetching: false, error: null };
        case types.HP_GET_FORM_FAILURE:
            return { ...state, isFetching: false, error: action.error };

        case types.HP_GET_SUBSCRIPTION_START:
            return { ...state, isFetching: true };
        case types.HP_GET_SUBSCRIPTION_SUCCESS:
            return { ...state, subscription: action.subscription, isFetching: false, error: null };
        case types.HP_GET_SUBSCRIPTION_FAILURE:
            return { ...state, isFetching: false, error: action.error, subscription: null };

        case types.HP_GET_DENTAL_INVOICE_DETAIL_START:
            return { ...state, isFetching: true };
        case types.HP_GET_DENTAL_INVOICE_DETAIL_SUCCESS:
            return { ...state, dentalInvoiceDetails: action.dentalInvoiceDetails, isFetching: false, error: null };
        case types.HP_GET_DENTAL_INVOICE_DETAIL_FAILURE:
            return { ...state, isFetching: false, error: action.error, subscription: null };

        case types.HP_GET_GROUPED_PROCEDURES_START:
            return { ...state, isFetching: true };
        case types.HP_GET_GROUPED_PROCEDURES_SUCCESS:
            return { ...state, groupedProcedures: action.groupedProcedures, isFetching: false, error: null };
        case types.HP_GET_GROUPED_PROCEDURES_FAILURE:
            return { ...state, isFetching: false, error: action.error };

        case types.HP_GET_GROUPED_PROCEDURES_BY_CPT_START:
            return { ...state, isFetching: true };
        case types.HP_GET_GROUPED_PROCEDURES_BY_CPT_SUCCESS:
            return { ...state, cptProcedures: action.cptProcedures, isFetching: false, error: null };
        case types.HP_GET_GROUPED_PROCEDURES_BY_CPT_FAILURE:
            return { ...state, isFetching: false, error: action.error };

        case types.HP_GET_PROCEDURE_COST_START:
            return { ...state, isFetching: true };
        case types.HP_GET_PROCEDURE_COST_SUCCESS:
            return { ...state, procedureCost: action.procedureCost, isFetching: false, error: null };
        case types.HP_GET_PROCEDURE_COST_FAILURE:
            return { ...state, isFetching: false, error: action.error };
        case types.HP_GET_PROCEDURE_COST_CLEAR:
            return { ...state, procedureCost: null, error: null };

        case types.HP_GET_TAX_DOCUMENT_LIST_START:
            return { ...state, isFetching: true };
        case types.HP_GET_TAX_DOCUMENT_LIST_SUCCESS:
            return { ...state, taxDocumentsList: action.taxDocumentsList, isFetching: false, error: null };
        case types.HP_GET_TAX_DOCUMENT_LIST_FAILURE:
            return { ...state, taxDocumentsList: null, error: null };

        case types.HP_GET_TAX_DOCUMENT_URL_START:
            return { ...state, isFetching: true };
        case types.HP_GET_TAX_DOCUMENT_URL_SUCCESS:
            return { ...state, taxDocumentUrl: action.taxDocumentUrl, isFetching: false, error: null };
        case types.HP_GET_TAX_DOCUMENT_URL_FAILURE:
            return { ...state, taxDocumentUrl: null, error: null };

        case types.HP_GET_SUPPORT_NOTIFICATION_START:
            return { ...state, isFetching: true };
        case types.HP_GET_SUPPORT_NOTIFICATION_SUCCESS:
            return { ...state, supportNoteMessage: action.supportMessage, isFetching: false, error: null };
        case types.HP_GET_SUPPORT_NOTIFICATION_FAILURE:
            return { ...state, supportNoteMessage: null, error: null };


        default:
            return { ...state };
    }
}
